import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_private/_route/_internal/introductions/',
)({
  beforeLoad: () => {
    throw redirect({ replace: true, to: '/trending' });
  },
});
